import { useCallback } from 'react';
import useFilters from './useFilters';
import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';

const useArticle8Filter = () => {
  const { query, handleFilterChange, extractedOptions } = useFilters();
  const { scheme } = useSelector((state: RootState) => state.global);

  const handleEntityChange = useCallback(
    (value: string) => {
      const selectedOption = extractedOptions.find(
        (opt) => opt.value === value,
      );
      handleFilterChange(value, selectedOption?.key || '');
    },
    [extractedOptions, handleFilterChange],
  );

  const handleClearFilter = useCallback(() => {
    handleFilterChange('', '');
  }, [handleFilterChange]);

  return {
    scheme,
    query,
    extractedOptions,
    handleFilterChange,
    handleEntityChange,
    handleClearFilter,
  };
};

export default useArticle8Filter;
